import { useMutation, useQuery } from '@apollo/client';
import { AccountClient, MockTicketClient } from '@nile/graphql';
import UserForm from '@nile/client_management/src/Containers/Requester/UserForm';
import { UPDATE_CLIENT_USER } from '@nile/graphql/src/Mutation/client';
import {
  GET_CLIENT_USER,
  GET_CLIENT_USERS
} from '@nile/graphql/src/Query/client';
import {
  Loader,
  toast,
  useUserMSPCheckHook,
  AppContext,
  useActivityTracker
} from '@nile/components';
import { cloneDeep } from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { useFlags } from 'launchdarkly-react-client-sdk';
// import AllClientTickets from '@nile/client_management/src/Containers/ClientDetails/AllClientTickets';

function EditUserNew(props) {
  const appContext = useContext(AppContext);
  const flags = useFlags();
  const {
    data: user,
    loading: employeeLoading,
    error: employeeError
  } = useQuery(GET_CLIENT_USER, {
    variables: {
      userId: props.id,
      userCustomFields: true
    },
    client: AccountClient,
    fetchPolicy: 'network-only'
  });
  const context = useContext(TicketContext);
  const [updateUser, { loading, error }] = useMutation(UPDATE_CLIENT_USER, {
    client: AccountClient,
    onCompleted({ updateClientUser }) {
      if (updateClientUser) {
        toast('success', 'User updated successfully');
        if (props.actions.refreshTable) {
          props.actions.refreshTable();
        }
        if (props.actions.callback) {
          props.actions.callback(updateClientUser);
        }
      }
      if (props.actions?.back) {
        props.actions.back();
      } else {
        // back();
        if (props?.actions?.closeRequesterModal) {
          props.actions.closeRequesterModal();
        }
      }
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });
  useEffect(() => {
    console.log(props.mixpanelSource);
    props?.mixpanelSource &&
      useActivityTracker({
        event: 'requester_popup',
        data: { source: props?.mixpanelSource }
      });
  }, []);

  const back = useCallback(() => {
    context.closeTab();
  }, []); // eslint-disable-line

  const switchToEdit = useCallback((data, type) => {
    if (!props.actions.back) {
      back();
    }
    props.actions.switchMode(data, type);
  }, []);

  const actions = {
    primaryAction: updateUser,
    back: props?.actions?.closeRequesterModal || back,
    switchToEdit: switchToEdit,
    actionType: props.type,
    ...props.actions
  };

  const updateRequesterData = (formData) => {
    if (props.actions.updateRequesterData) {
      props.actions.updateRequesterData(formData);
    }
  };

  const isMSP = useUserMSPCheckHook();

  if (employeeLoading)
    return (
      <div className="p20 bg-white vh90 br10">
        <Loader />
      </div>
    );
  if (employeeError) return <div>error</div>;

  return (
    <>
      <UserForm
        actions={actions}
        user={user.getClientUser}
        accountId={props.accountId}
        newLayout={props.newLayout}
        isMSP={isMSP}
        updateRequesterData={updateRequesterData}
        appContext={appContext}
        tabContext={context}
        globalTabContext={props?.globalTabContext}
      />
    </>
  );
}

export default withRouter(EditUserNew);
